import { OPEN_API_TEST, OPEN_API_PRO, BASE_URL } from "@/constants/index";

export function returnOutboundApi() {
  const apiUrlTest = "/gateway/edi/product/query"; //测试环境接口地址
  // const isCn = (localStorage.getItem("lang") || "CN") === "CN";
  return {
    //当前请求URL
    apiBaseUrl: BASE_URL + `${apiUrlTest}`,

    onlineData: {
      // 接口描述
      apiDesc: "apiDocDesc.outboundordercallbackapiDesc",
      //接口地址
      testApi: `${OPEN_API_TEST}${apiUrlTest}`,
      proApi: `${OPEN_API_PRO}${apiUrlTest}`,
      infos: [],
      //参数描述  START
      postDataList: [
        //   请求头参数
        {
          title: "onlineDoc.请求参数",
          value: [
            {
              name: "requestId",
              type: "varchar(200)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.requestIdDesc338"
            },
            {
              name: "warehouseCode",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.warehouseCodeDesc339"
            },
            {
              name: "warehouseName",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.warehouseNameDesc340"
            },
            {
              name: "customerCode",
              type: "varchar(50)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.customerCodeDesc341"
            },
            {
              name: "storerKey",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.storerKeyDesc342"
            },
            {
              name: "providerOrderId",
              type: "varchar(200)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.providerOrderIdDesc343"
            },
            {
              name: "deliveryOrderCode",
              type: "varchar(200)",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.deliveryOrderCodeDesc344"
            },
            {
              name: "source",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.sourceDesc345"
            },
            {
              name: "platformNumber",
              type: "varchar(200)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.platformNumberDesc346"
            },
            {
              name: "sourceSystem",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.sourceSystemDesc347"
            },
            {
              name: "outBizNo",
              type: "varchar(200)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.outBizNoDesc348"
            },
            {
              name: "scanTime",
              type: "date",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.scanTimeDesc349"
            },
            {
              name: "logisticCode",
              type: "varchar(50)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.logisticCodeDesc350"
            },
            {
              name: "trackingNumber",
              type: "varchar(200)",
              require: "N",
              normal: "",
              describe: "apiDocDesc.trackingNumberDesc351"
            },
            {
              name: "reserved1",
              type: "json",
              require: "N",
              normal: "",
              describe: "apiDocDesc.reserved1Desc352"
            },
            {
              name: "packages",
              type: "Array",
              require: "",
              normal: "",
              describe: "apiDocDesc.packagesDesc353",
              children: [
                {
                  name: "logisticCode",
                  type: "varchar(50)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.logisticCodeDesc354"
                },
                {
                  name: "logisticName",
                  type: "varchar(200)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.logisticNameDesc355"
                },
                {
                  name: "trackingNumber",
                  type: "varchar(200)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.trackingNumberDesc356"
                },
                {
                  name: "packageCode",
                  type: "varchar(200)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.packageCodeDesc357"
                },
                {
                  name: "packagesitemsList",
                  type: "Object",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.packagesitemsListDesc358",
                  children: [
                    {
                      name: "itemCode",
                      type: "varchar(200)",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.itemCodeDesc359"
                    },
                    {
                      name: "quantity",
                      type: "int",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.quantityDesc360"
                    }
                  ]
                },
                {
                  name: "packageMaterialList",
                  type: "Object",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.packageMaterialListDesc361",
                  children: [
                    {
                      name: "Materialtype",
                      type: "varchar(200)",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.MaterialtypeDesc362"
                    },
                    {
                      name: "quantity",
                      type: "int",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.quantityDesc363"
                    }
                  ]
                }
              ]
            },
            {
              name: "orderLines",
              type: "Array",
              require: "",
              normal: "",
              describe: "apiDocDesc.orderLinesDesc364",
              children: [
                {
                  name: "lineNo",
                  type: "int",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.lineNoDesc365"
                },
                {
                  name: "itemCode",
                  type: "varchar(50)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.itemCodeDesc366"
                },
                {
                  name: "number",
                  type: "int",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.numberDesc367"
                },
                {
                  name: "actualQty",
                  type: "int",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.actualQtyDesc368"
                },
                {
                  name: "inventoryType",
                  type: "varchar(50)",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.inventoryTypeDesc369"
                },
                {
                  name: "batchCode",
                  type: "varchar(50)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.batchCodeDesc370"
                },
                {
                  name: "produceCode",
                  type: "varchar(50)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.produceCodeDesc371"
                },
                {
                  name: "productDate",
                  type: "date",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.productDateDesc372"
                },
                {
                  name: "remark",
                  type: "varchar(500)",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.remarkDesc373"
                },
                {
                  name: "reserved1",
                  type: "json",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.reserved1Desc374"
                },
                {
                  name: "snList",
                  type: "Array",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.snListDesc375",
                  children: [
                    {
                      name: "snList",
                      type: "String[]",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.snListDesc376"
                    }
                  ]
                },
                {
                  name: "batches",
                  type: "Array",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.batchesDesc377",
                  children: [
                    {
                      name: "actualQty",
                      type: "int",
                      require: "Y",
                      normal: "",
                      describe: "apiDocDesc.actualQtyDesc378"
                    },
                    {
                      name: "inventoryType",
                      type: "varchar(50)",
                      require: "Y",
                      normal: "",
                      describe: "apiDocDesc.inventoryTypeDesc379"
                    },
                    {
                      name: "batchCode",
                      type: "varchar(50)",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.batchCodeDesc380"
                    },
                    {
                      name: "productDate",
                      type: "date",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.productDateDesc381"
                    },
                    {
                      name: "expireDate",
                      type: "date",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.expireDateDesc382"
                    },
                    {
                      name: "produceCode",
                      type: "varchar(50)",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.produceCodeDesc383"
                    },
                    {
                      name: "supplierCode",
                      type: "varchar(64)",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.supplierCodeDesc384"
                    },
                    {
                      name: "supplierName",
                      type: "varchar(200)",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.supplierNameDesc385"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      //参数描述  END
      //报文描述 start
      responseDataList: [
        {
          title: "onlineDoc.响应参数",
          value: [
            {
              name: "success",
              type: "Boolean",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.successDesc386"
            },
            {
              name: "code",
              type: "Number",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.codeDesc387"
            },
            {
              name: "request_id",
              type: "String",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.request_idDesc388"
            },
            {
              name: "message",
              type: "String",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.messageDesc389"
            },
            {
              name: "data",
              type: "Object",
              require: "N",
              normal: "",
              describe: "apiDocDesc.dataDesc390"
            }
          ]
        }
      ],
      //请求示例
      requestCode: {
        customerCode: "TOMORO",
        deliveryOrderCode: "SO24051000004947",
        logisticCode: "JT",
        orderLines: [
          {
            actualQty: 1,
            batches: [
              {
                actualQty: 1,
                batchCode: "20240510",
                expireDate: "2024-06-09",
                inventoryType: "ZP",
                productDate: "2024-05-10",
                supplierCode: "SUPP02850",
                supplierName: ""
              }
            ],
            inventoryType: "ZP",
            itemCode: "21010002",
            number: 3333,
            reserved1: {
              cgeneralbid: "1001A110000000CMSPPC"
            },
            snList: {
              sn: ["iECUks0M8v"]
            }
          },
          {
            actualQty: 0,
            batches: [],
            inventoryType: "ZP",
            itemCode: "21010003",
            number: 4444,
            reserved1: {
              cgeneralbid: "1001A110000000CMSPPD"
            },
            snList: {
              sn: ["iECUks0M8v"]
            }
          }
        ],
        packages: [
          {
            logisticCode: "JT",
            logisticName: "极兔",
            packageCode: "TMOCS-0164",
            packageItemList: [
              {
                itemCode: "21010002",
                quantity: 1
              }
            ],
            packageMaterialList: [
              {
                quantity: 1
              }
            ]
          }
        ],
        platformNumber: "DC240500003",
        providerOrderId: "DC240500003",
        requestId: "0b3a3d18d03645a98f9aa4d274348a52",
        reserved1: {
          vtrantypecode: "4Y-Cxx-04",
          cgeneralhid: "1001A110000000CMSPPB"
        },
        scanTime: "2024-05-11 09:55:50",
        source: "TOMORO",
        storerKey: "D07",
        warehouseCode: "TMOCS",
        warehouseName: "TOMORO测试仓"
      },
      //返回示例
      responseCode: {
        code: 0,
        message: "成功",
        request_id: "9a53af6aaeb54ceab6637df2c8805369",
        success: true
      }
    }
  };
}
